export default {
  reset_password_title: "重置密碼",
  invalid_reset_token: "重置密碼連結無效或已過期",
  invalid_reset_token_desc: "您提供的重置密碼連結無效或已過期。請申請新的重置密碼連結。",
  password_reset_success: "您的密碼已成功重置",
  password_reset_success_desc: "您的密碼已成功更改。您現在可以使用新密碼登入。",
  reset_password_desc: "請在下方輸入您的新密碼",
  password_required: "請輸入您的密碼",
  password_invalid: "密碼至少需要 8 個字元，並包含字母、數字和特殊字元",
  password_placeholder: "輸入您的密碼",
  confirm_password_required: "請確認您的密碼",
  passwords_do_not_match: "兩次輸入的密碼不一致",
  confirm_password_placeholder: "確認密碼",
  reset_password: "設定新密碼",
  password_same_as_old: "新密碼不能與舊密碼相同",
  password_reset_failed: "密碼重置失敗",
};
